import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, Title } from '@angular/platform-browser';

import { ActivatedRoute } from '@angular/router';

import { environment } from 'src/environments/environment';
import { RequestServiceService } from '../core/services/request-service/request-service.service';

@Component({
  selector: 'app-webview',
  templateUrl: './webview.component.html',
  styleUrls: ['./webview.component.scss']
})
export class WebviewComponent implements OnInit {
  webviewData: any;

  get url(): SafeResourceUrl {
    return this._url;
  }

  get path(): string {
    return this._path;
  }

  

  private _url: SafeResourceUrl = '';

  private _path = '';

  private _urlParam = '';



  constructor(
    private activatedRoute: ActivatedRoute,
    private requestApiService: RequestServiceService,
    private domSanitizer: DomSanitizer) {

    this.activatedRoute.params.subscribe((params) => {
      console.log(params)
      this._path = params['path'];
      if (this._path === 'terms-n-condition') {
        this._path = 'Terms And Use';

      } else if (this._path === 'faq') {
        this._path = 'Frequently Asked Questions';

      } else if (this._path === 'about-us') {
        this._path = 'About Us';

      } else if (this._path === 'privacy-policy') {
        this._path = 'Privacy Policy';

      } else if (this._path === 'support') {
        this._path = 'Support';

      }
      this.getWebviewUrl()
    });
   

  }

  getWebviewUrl() {
    this.requestApiService.getWebviewUrl().then(apiResponseData => {
      if (apiResponseData.success) {
        this.webviewData = apiResponseData.data.external_links.list;

        // Use Array.prototype.filter() to filter the array based on the title
        const filteredData = this.webviewData.filter((item: any) => item.title === this._path);

        // Update this.webviewData with the filtered data
        this.webviewData = filteredData[0];
        this._url = this.domSanitizer.bypassSecurityTrustResourceUrl(this.webviewData.link);
        
      }
    });
  }
  ngOnInit(): void {



  }



  public onBack() {
    window.history.back();
  }

}
